import React from 'react';
import './Integration.css';

const Integration = () => {
  return (
    <section className="integration-section">
      <div className="integration-container">
        <h2>Seamless integration with</h2>
        
        <div className="integration-cards">
          <div className="integration-card">
            
            <h3 className="card-title" style={{color:'#0191c6'}}>NHS</h3>
            
            <div className="card-hover-content">
              <h3 style={{color:'white', marginBottom: '15px'}}>NHS</h3>
              <p style={{color:'white', marginBottom: '20px'}}>Deliver safe, high-quality care to patients at the right time and place.</p>
              <ul style={{color:'white', marginBottom: '20px', listStyleType: 'disc', paddingLeft: '20px'}}>
                <li>Secure data sharing</li>
                <li>Compliant with NHS standards</li>
                <li>Streamlined patient care</li>
              </ul>
              <a href="#" className="learn-more" style={{color:'white', marginTop: 'auto'}}>
                Learn more
                <span className="arrow-icon">→</span>
              </a>
              <div className="blue-overlay"></div>
            </div>
          </div>

          <div className="integration-card">
            <img 
              src="/images/EMRs.png" 
              alt="EMRs" 
              className="integration-image" 
              style={{ width: "100px", height: "100px", objectFit: "contain" }} 
            />
            <h3 className="card-title" style={{color:'#0191c6'}}>EMRs</h3>
            
            <div className="card-hover-content">
              <h3 style={{color:'white', marginBottom: '15px'}}>EMRs</h3>
              <p style={{color:'white', marginBottom: '20px'}}>Digital, secure versions of traditional paper medical records.</p>
              <ul style={{color:'white', marginBottom: '20px', listStyleType: 'disc', paddingLeft: '20px'}}>
                <li>Automatic data entry</li>
                <li>Structured medical notes</li>
                <li>Seamless integration</li>
              </ul>
              <a href="#" className="learn-more" style={{color:'white', marginTop: 'auto'}}>
                Learn more
                <span className="arrow-icon">→</span>
              </a>
              <div className="blue-overlay"></div>
            </div>
          </div>

          <div className="integration-card">
            <img 
              src="/images/medical-consultation.png" 
              alt="Telehealth portals" 
              className="integration-image" 
              style={{ width: "100px", height: "100px", objectFit: "contain" }} 
            />
            <h3 className="card-title" style={{color:'#0191c6'}}>Telehealth portals</h3>
            
            <div className="card-hover-content">
              <h3 style={{color:'white', marginBottom: '15px'}}>Telehealth portals</h3>
              <p style={{color:'white', marginBottom: '20px'}}>Enable remote care through virtual consultations and messaging.</p>
              <ul style={{color:'white', marginBottom: '20px', listStyleType: 'disc', paddingLeft: '20px'}}>
                <li>Real-time transcription</li>
                <li>Multilingual support</li>
                <li>Enhanced patient experience</li>
              </ul>
              <a href="#" className="learn-more" style={{color:'white', marginTop: 'auto'}}>
                Learn more
                <span className="arrow-icon">→</span>
              </a>
              <div className="blue-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integration; 